"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const filter = require("../filter.cjs");
const typeFilter = (documentType) => {
  return filter.filter.at("document.type", documentType);
};
exports.typeFilter = typeFilter;
//# sourceMappingURL=typeFilter.cjs.map
